import { Component, OnDestroy, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { concat, of, from, Subscription, Subject, Observable } from 'rxjs';
import { map, switchMap, concatMap, filter, debounceTime, distinctUntilChanged, concatAll, finalize, tap } from 'rxjs/operators';

import { environment } from 'src/environments/environment';
import { round1, round2 } from 'src/app/shared/round';

import { Document, DocItems, DocInheritanceRule } from 'src/app/shared/document';

import { GlobalSettingsData } from 'src/app/shared/global-settings-data'
import { GetglobalsettingsService } from 'src/app/services/getglobalsettings.service'

import { ProductApiService } from 'src/app/services/product-api.service';
import { DocumentApiService } from 'src/app/services/document-api.service';
import { ClientApiService } from 'src/app/services/client-api.service';
import { RestApiService } from 'src/app/services/rest-api.service';

@Component({
  selector: 'app-new-document-dlg-process-tran-inter',
  templateUrl: './new-document-dlg-process-tran-inter.component.html',
  styleUrl: './new-document-dlg-process-tran-inter.component.css',
  encapsulation: ViewEncapsulation.None
})
export class NewDocumentDlgProcessTranInterComponent {

}
